import styled from 'styled-components';

export const Container = styled.header`
  h3 {
    display: inline-block;
    font-weight: 600;
  }

  p {
    color: rgba(0, 0, 0, 0.5);
    font-size: 14px;
  }
`;
